export const DOCUMENT_OPTIONS = [
  { id: 0, nameKey: "documents.passport_front" },
  { id: 3, nameKey: "documents.passport_back" },
  { id: 1, nameKey: "documents.insurance" },
  { id: 4, nameKey: "documents.medical_note" },
  { id: 2, nameKey: "documents.disability_note_front" },
  { id: 5, nameKey: "documents.disability_note_back" },
];

export const OPERATION_OPTIONS = [
  { id: 2, nameKey: "notificationsPage.changing" },
  { id: 0, nameKey: "notificationsPage.downloading" },
  { id: 1, nameKey: "notificationsPage.delete" },
];
